function SecurityHubPage() {
    return (
        <div>
            Security Hub page
        </div>
    )
}

export default SecurityHubPage;
